import { DocumentVersionDetailsForBulkUserReplacement } from './document-version-details-for-bulk-user-replacement';
import { AppliedFilters } from '../../shared-components/panel-hub/models/applied-filters';
import { PaginationState } from '../../shared-components/panel-hub/models/pagination-state';
import { SortCriteria } from '../../shared-components/panel-hub/models/sort-criteria';


export class UserReplacementDetails {

    documentNumberAndVersion?: DocumentVersionDetailsForBulkUserReplacement[];

    deselectedDocumentNumberAndVersion?: DocumentVersionDetailsForBulkUserReplacement[];

    userToRemove?: string | null;

    userToAdd?: string;

    assignments?: number[];

    isSelectAcrossAllPages?: boolean = false;

    currentFilters?: AppliedFilters | null;

    currentSort?: SortCriteria | null;

    currentPagination?: PaginationState | null;

    primarySearchText?: string | null;

    secondarySearchText?: string | null;
}